import {
  Container,
  Center,
  Loader,
  Paper,
  Button,
  Text,
  Badge,
  Group,
  TextInput,
  Grid,
  Stack,
  Slider,
  // useComputedColorScheme,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import ApiKeys from "../../../Boilerplate/Tenants/ApiKeys";

import { notifications } from "@mantine/notifications";
import { Link } from "wouter";
import { checkoutAddon, customerPortal, getTenantProfile, updateTenantProfile } from "../api";
import { useStore } from "../store";
import { useBrandContext } from "../Brands/brandContext";

function UsageOverview({ usage }) {
  const dataPointsLimit = usage.dataPointsLimit ?? 0;
  const promptsLimit = usage.promptsLimit ?? 0;

  return (
    <>
      <Text fz="xs" tt="uppercase" fw={600}>
        Data Points
      </Text>

      <Slider
        mb="lg"
        disabled
        marks={[
          { value: 0, label: "0" },
          {
            value: dataPointsLimit / 2,
            label: (dataPointsLimit / 2).toString(10),
          },
          {
            value: dataPointsLimit,
            label: dataPointsLimit.toString(10),
          },
        ]}
        min={0}
        max={dataPointsLimit}
        defaultValue={usage.dataPointsUsed ?? 0}
      />

      <Text fz="xs" tt="uppercase" fw={600}>
        Prompts
      </Text>

      <Slider
        mb="lg"
        disabled
        marks={[
          { value: 0, label: "0" },
          {
            value: promptsLimit / 2,
            label: (promptsLimit / 2).toString(10),
          },
          {
            value: promptsLimit,
            label: promptsLimit.toString(10),
          },
        ]}
        min={0}
        max={promptsLimit}
        defaultValue={usage.promptsUsed ?? 0}
      />
    </>
  );
}

function PackagingOverview({ packaging, onBuyCluster, onBuyMentions, buying }) {
  if (!packaging) return null;

  return (
    <Stack gap="xs" mb="md">
      <Text fz="xs" tt="uppercase" fw={600}>
        This month
      </Text>
      {packaging.trialing && (
        <Text size="sm" c="dimmed">
          Trial includes one researched cluster. Subscribe to Brand for two a month.
        </Text>
      )}
      <Group justify="space-between">
        <Text size="sm">Researched clusters</Text>
        <Text size="sm" fw={600}>
          {packaging.clustersRemaining} of {packaging.clustersIncluded + packaging.clustersExtra} left
        </Text>
      </Group>
      <Group justify="space-between">
        <Text size="sm">Classified mentions</Text>
        <Text size="sm" fw={600}>
          {(packaging.mentionsRemaining ?? 0).toLocaleString()} of{" "}
          {(packaging.mentionsIncluded + packaging.mentionsExtra).toLocaleString()} left
        </Text>
      </Group>
      <Group gap="xs" justify="flex-end">
        <Button size="xs" variant="light" loading={buying === "cluster"} onClick={onBuyCluster}>
          Extra cluster $19
        </Button>
        <Button size="xs" variant="light" loading={buying === "mentions"} onClick={onBuyMentions}>
          {packaging.mentionsPlusQuantity > 0
            ? "Add 2,000 more · $29/mo"
            : "Mentions Plus $29/mo"}
        </Button>
      </Group>
    </Stack>
  );
}

export default function TenantProfileEdit() {
  const [isLoading, setIsLoading] = useState(false);
  const [buying, setBuying] = useState(null);

  const profile = useStore((state) => state.tenantProfile);
  const setTenantProfile = useStore((state) => state.setTenantProfile);

  const { selectedBrand, brands } = useBrandContext();

  // var theme = useComputedColorScheme();

  const form = useForm({
    initialValues: {
      name: "",
    },
  });

  useEffect(() => {
    getTenantProfile().then((data) => {
      var formInit = { name: data.name || "" };
      form.setValues(formInit);
      setTenantProfile(data);
    });
  }, []);

  if (!profile)
    return (
      <Container size="sm">
        <Center>
          <Loader />
        </Center>
      </Container>
    );

  return (
    <Container size="md">
      <Grid>
        <Grid.Col span={12}>
          <Paper radius="md" p="lg">
            <Text mb="sm" fz="xl" fw={500}>
              Settings
            </Text>
            <form
              onSubmit={form.onSubmit((values) => {
                updateTenantProfile(values).then((data) => {
                  setTenantProfile(data);
                  notifications.show({
                    title: "Profile updated",
                    message: "Your tenant profile has been updated",
                    color: "teal",
                  });
                });
              })}
            >
              <TextInput
                label="Organization Name"
                placeholder="Best Prompts, Inc."
                required
                {...form.getInputProps("name")}
              />

              <Group mt="md" justify="flex-end">
                <Button variant="outline" type="submit">
                  Save
                </Button>
              </Group>
            </form>
          </Paper>
        </Grid.Col>

        {/* <Grid.Col span={12}>
          <Paper radius="md" p="lg">
            <Text mb="sm" fz="xl" fw={500}>
              Users
            </Text>

            <Group mt="md" justify="flex-end">
              <Button variant="outline" component={Link} to="/users">
                Manage users
              </Button>
            </Group>
          </Paper>
        </Grid.Col> */}

        {/* <Grid.Col span={12}>
          <Paper radius="md" p="lg">
            <Text mb="sm" fz="xl" fw={500}>
              Credits
            </Text>
            <Stack>
              <Group justify="space-between">
                <div>
                  {profile.creditTotals?.map((credit) => (
                    <Group key={credit.creditType}>
                      <Badge radius="xs" variant="dot" color="grape">
                        {credit.creditType}
                      </Badge>
                      <Text fz="lg">
                        <NumberFormatter
                          value={credit.creditsLeft}
                          decimalScale={0}
                          thousandSeparator
                        />
                      </Text>
                    </Group>
                  ))}
                </div>

                <Button
                  variant="outline"
                  loading={isLoading}
                  component={Link}
                  to="/credits"
                >
                  Buy credits
                </Button>
              </Group>
            </Stack>
          </Paper>
        </Grid.Col> */}

        <Grid.Col span={12}>
          <Paper radius="md" p="lg">
            <Text mb="sm" fz="xl" fw={500}>
              Subscription
            </Text>
            <Stack>
              <Group mb="md" justify="space-between">
                <Text>Active plan</Text>
                <Badge>{profile.plan ? profile.plan : "None"}</Badge>
              </Group>
              <PackagingOverview
                packaging={profile.packaging}
                buying={buying}
                onBuyCluster={async () => {
                  setBuying("cluster");
                  try {
                    const data = await checkoutAddon("extra-cluster");
                    if (data?.redirectUrl) window.location = data.redirectUrl;
                  } finally {
                    setBuying(null);
                  }
                }}
                onBuyMentions={async () => {
                  setBuying("mentions");
                  try {
                    const data = await checkoutAddon("mentions-plus");
                    if (data?.redirectUrl) {
                      window.location = data.redirectUrl;
                      return;
                    }
                    if (data?.applied) {
                      const profile = await getTenantProfile();
                      setTenantProfile(profile);
                      notifications.show({
                        title: "Mentions Plus",
                        message: "2,000 more classified mentions this month, and every month until you cancel.",
                        color: "teal",
                      });
                    }
                  } finally {
                    setBuying(null);
                  }
                }}
              />

              <Text>Current month usage</Text>
              {profile?.usage && <UsageOverview usage={profile.usage} />}

              <Group justify="flex-end">
                {profile.plan ? (
                  <Button
                    loading={isLoading}
                    variant="outline"
                    onClick={() => {
                      setIsLoading(true);
                      customerPortal()
                        .then((data) => {
                          window.location = data.redirectUrl;
                        })
                        .finally(() => {
                          setIsLoading(false);
                        });
                    }}
                  >
                    Manage subscription
                  </Button>
                ) : (
                  <Button
                    loading={isLoading}
                    variant="filled"
                    component={Link}
                    to="/pricing"
                  >
                    Create subscription
                  </Button>
                )}
              </Group>
            </Stack>
          </Paper>
        </Grid.Col>

        <Grid.Col span={12}>
          <Paper withBorder mt="xl" p="lg" radius="md">
            <ApiKeys
              additionalData={{ brandId: selectedBrand?.id }}
              brandName={selectedBrand?.name}
              brands={brands}
            />
          </Paper>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
